export const tenureCheck_ko = {
  'title-section': {
    title: '재직 인증',
    description: 'CIAM 시스템을 사용하기 위해 이메일 인증을 진행해 주세요',
  },
  form: {
    fields: {
      code: {
        label: '인증 코드',
        placeholder: '인증 코드를 입력해주세요.',
      },
      button: {
        continue: '인증하기',
        resend: '재전송',
      },
    },
    'resend-success': '인증 코드가 전송되었습니다.',
  },
  errors: {
    'invalid-parameter-value': '잘못된 인증 코드입니다.',
    'send-default': '인증 코드 전송 중 오류가 발생했습니다.',
    'verify-default': '인증 코드 인증 중 오류가 발생했습니다.',
  },
};
